import { INewbuilding } from '../../../../types/newbuildingHeader';

export function getFirstBuilder(newbuilding: INewbuilding | null) {
  if (newbuilding?.builders) {
    return newbuilding.builders[0] ?? undefined;
  }

  return undefined;
}
